import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login1 from "./pages/Login";
import Login2 from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ManageCars from "./pages/ManageCars";
import StopSale from "./pages/StopSale";
import CarGroup from "./pages/CarGroup";
import UserManagement from "./pages/UserManagement";
import SeasonName from "./pages/SeasonName";
import SeasonDuration from "./pages/SeasonDuration";
import CarPrice from "./pages/CarPrice";
import ProtectedRoute from "./components/ProtectedRoute";
import CouponCode from "./pages/CouponCode";
import InsuranceDetail from "./pages/InsuranceDetail";
import OptionalExtraDetail from "./pages/OptionalExtraDetail";
import ManageLocation from "./pages/ManageLocation";
import InsuranceDaySlab from "./pages/ManageInsurance";
import ManageContents from "./pages/ManageContents";
import ManageFaq from "./pages/ManageFaq";
import ManageOnlineBooking from "./pages/ManageOnlineBooking";
import ManageSetting from "./pages/ManageSetting";
import ManageOptionalExtra from "./pages/ManageOptionalExtra";
import ManageBrand from "./pages/ManageBrand";
import ManageTransmission from "./pages/ManageTransmission";
import ManageEngcapacity from "./pages/ManageEngcapacity";
import CarItems from "./pages/CarItems";
import ManageRegularClients from "./pages/ManageRegularClients";
import AddUser from "./pages/AddUser";
import AddCar from "./pages/AddCar";
import AddRegularClient from "./pages/AddRegularClient";
import SendMailRegularClient from "./pages/SendMailRegularClient";
import SpecialDiscounter from "./pages/SpecialDiscounter";
import SpecialHourCharge from "./pages/SpecialHourCharge";
import AddCoupon from "./pages/AddCoupon";
import ManageContacts from "./pages/ManageContacts";
import ManageDelonline from "./pages/ManageDelonlineBooking";
import ManageModifayCancle from "./pages/ManageModifayCancle";
import AddSeo from "./pages/AddSeo";
import AddLocation from "./pages/AddLocation";
import GenerateBookingsExcal from "./pages/GenerateBookingsExcal";
import ManageMultipleBookingDetails from "./pages/ManageMultipleBookingDetails";
import ManageLanguage from "./pages/ManageLanguage";
import ManageInfoinEnglish from "./pages/ManageInfoinEnglish";
import StaticInformation from "./pages/StaticInformation";
import DynamicInformation from "./pages/DynamicInformation";
import MessagesInformation from "./pages/MessagesInformation";
import NotFound from "./pages/NotFound";
import ManageSeo from "./pages/ManageSeo";
import ChangePassword from "./pages/ChangePassword";
import ManageBanner from "./pages/ManageBanner";
import RentDurations from "./pages/Rentdurations";
import { AppToast } from "./components/AppToast";

// Code - 1416E

function App() {
  return (
    
    <BrowserRouter>
    <AppToast />
      <Routes>
        <Route path="/" element={<Navigate to="/admin" />} />

        {/* Admin pages start */}
        <Route path="/admin" element={<Login2 />} />
        <Route path="/login" element={<Login1 />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        {/* <Route path="/users" element={<Users />} /> */}

        {/* Code - 1416S */}
        <Route
          path="/manage-brand"
          element={
            <ProtectedRoute>
              <ManageBrand />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-transmission"
          element={
            <ProtectedRoute>
              <ManageTransmission />
              
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-engcapacity"
          element={
            <ProtectedRoute>
              <ManageEngcapacity />
            </ProtectedRoute>
          }
        />
        <Route
          path="/caritems"
          element={
            <ProtectedRoute>
              <CarItems />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-cars"
          element={
            <ProtectedRoute>
              <ManageCars />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-cars/add"
          element={
            <ProtectedRoute>
              {" "}
              <AddCar />{" "}
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-cars/edit"
          element={
            <ProtectedRoute>
              <AddCar />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cargroup"
          element={
            <ProtectedRoute>
              <CarGroup />
            </ProtectedRoute>
          }
        />
        <Route
          path="/stop-sale"
          element={
            <ProtectedRoute>
              <StopSale />
            </ProtectedRoute>
          }
        />
        <Route
          path="/season-name"
          element={
            <ProtectedRoute>
              <SeasonName />
            </ProtectedRoute>
          }
        />
        <Route
          path="/season-duration"
          element={
            <ProtectedRoute>
              <SeasonDuration />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-regular-clients"
          element={
            <ProtectedRoute>
              <ManageRegularClients />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-regular-clients/add"
          element={
            <ProtectedRoute>
              <AddRegularClient />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-regular-clients/edit"
          element={
            <ProtectedRoute>
              <AddRegularClient />{" "}
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-regular-clients/send-mail"
          element={
            <ProtectedRoute>
              <SendMailRegularClient />
            </ProtectedRoute>
          }
        />
        <Route
          path="/rent-durations"
          element={
            <ProtectedRoute>
              <RentDurations />
            </ProtectedRoute>
          }
        />
        <Route
          path="/car-price"
          element={
            <ProtectedRoute>
              <CarPrice />
            </ProtectedRoute>
          }
        />
        <Route
          path="/user-management"
          element={
            <ProtectedRoute>
              <UserManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/user-management/add"
          element={
            <ProtectedRoute>
              <AddUser />
            </ProtectedRoute>
          }
        />
        <Route
          path="/user-management/edit"
          element={
            <ProtectedRoute>
              {" "}
              <AddUser />
            </ProtectedRoute>
          }
        />
        <Route
          path="/special-discount"
          element={
            <ProtectedRoute>
              {" "}
              <SpecialDiscounter />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-special-hour"
          element={
            <ProtectedRoute>
              {" "}
              <SpecialHourCharge />
            </ProtectedRoute>
          }
        />
        <Route
          path="/coupon-code"
          element={
            <ProtectedRoute>
              <CouponCode />
            </ProtectedRoute>
          }
        />
        <Route
          path="/coupon-code/add"
          element={
            <ProtectedRoute>
              <AddCoupon />
            </ProtectedRoute>
          }
        />
        <Route
          path="/coupon-code/edit"
          element={
            <ProtectedRoute>
              {" "}
              <AddCoupon />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-insurance"
          element={
            <ProtectedRoute>
              <InsuranceDaySlab />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-faqs"
          element={
            <ProtectedRoute>
              <ManageFaq />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-contacts"
          element={
            <ProtectedRoute>
              <ManageContacts />
            </ProtectedRoute>
          }
        />
        <Route
          path="/del-online"
          element={
            <ProtectedRoute>
              <ManageDelonline />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-bookings"
          element={
            <ProtectedRoute>
              <ManageOnlineBooking />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-modifyacancel-requests"
          element={
            <ProtectedRoute>
              <ManageModifayCancle />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-seo"
          element={
            <ProtectedRoute>
              <ManageSeo />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-seo/add"
          element={
            <ProtectedRoute>
              <AddSeo />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-seo/edit"
          element={
            <ProtectedRoute>
              <AddSeo />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-content"
          element={
            <ProtectedRoute>
              <ManageContents />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-location"
          element={
            <ProtectedRoute>
              <ManageLocation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-location/add"
          element={
            <ProtectedRoute>
              <AddLocation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-location/edit"
          element={
            <ProtectedRoute>
              <AddLocation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/generate-manage-bookings-Excal"
          element={
            <ProtectedRoute>
              <GenerateBookingsExcal />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-multiple-booking-details"
          element={
            <ProtectedRoute>
              <ManageMultipleBookingDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-language"
          element={
            <ProtectedRoute>
              <ManageLanguage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-infoinenglish"
          element={
            <ProtectedRoute>
              <ManageInfoinEnglish />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-static-infos"
          element={
            <ProtectedRoute>
              <StaticInformation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-dynamic-infos"
          element={
            <ProtectedRoute>
              <DynamicInformation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-messages-infos"
          element={
            <ProtectedRoute>
              <MessagesInformation />
            </ProtectedRoute>
          }
        />

        {/* Code - 1416E */}

       
       
        
        <Route
          path="/insurance-detail"
          element={
            <ProtectedRoute>
              <InsuranceDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/optional-extra-detail"
          element={
            <ProtectedRoute>
              <OptionalExtraDetail />
            </ProtectedRoute>
          }
        />
      
      
        <Route
          path="/manage-optionalextra"
          element={
            <ProtectedRoute>
              <ManageOptionalExtra />
            </ProtectedRoute>
          }
        />
       
      
     
        <Route
          path="/manage-setting"
          element={
            <ProtectedRoute>
              <ManageSetting />
            </ProtectedRoute>
          }
        />
       
       
       
    
       
        <Route
          path="/manage-banners"
          element={
            <ProtectedRoute>
              <ManageBanner />
            </ProtectedRoute>
          }
        />
       
      

      
        <Route
          path="/change-password"
          element={
            <ProtectedRoute>
              <ChangePassword />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<NotFound />} />
       
      </Routes>
    </BrowserRouter>
  );
}

export default App;
